import { sizeGuide } from "@/utils/constants";
import styles from "./common.module.scss";

export default function SizeGuide({ sizeGuideType }) {
  let sizeGuideData = null;
  let sizeGuideCategoryText = "";
  switch (sizeGuideType) {
    case "clothing":
      sizeGuideData = sizeGuide.clothing;
      sizeGuideCategoryText = "Women's Apparel";
      break;
    case "shoes":
      sizeGuideData = sizeGuide.shoes;
      sizeGuideCategoryText = "Women's Footwear";
      break;
    case "jeans":
      sizeGuideData = sizeGuide.jeans;
      sizeGuideCategoryText = "Women's Apparel";
      break;
  }

  if (sizeGuideData) {
    const sizeGuideHeaderRow = (
      <tr>
        {sizeGuideData[0].map((item, index) => {
          return (
            <th key={index} className={index === 0 ? "hd-col bg-none" : ""}>
              {item}
            </th>
          );
        })}
      </tr>
    );

    const sizeGuideBodyRows = [];

    for (let i = 1; i < sizeGuideData.length; i++) {
      const row = sizeGuideData[i];
      sizeGuideBodyRows.push(
        <tr key={i}>
          {row.map((item, index) => {
            return (
              <td key={index} className={index === 0 ? "hd-col" : ""}>
                {item}
              </td>
            );
          })}
        </tr>
      );
    }

    return (
      <>
        <div className={styles.size_guide_wrapper}>
          <div className="no-hori-scroll">
            <p className="normal italic sizeguide-hd">Size guide</p>
            <p className="x-large light sizeguide-category">
              {sizeGuideCategoryText}
            </p>
            <p className="small sizeguide-txt">
              Please note: The following information is intended for use as a
              general guideline. Sizing and fit may vary somewhat by brand.
            </p>
          </div>
          <div className="hori-scroll">
            <table className="table">
              <thead>{sizeGuideHeaderRow}</thead>
              <tbody>{sizeGuideBodyRows}</tbody>
            </table>
          </div>
        </div>
      </>
    );
  }
}
